<script>
import Icon from '../../../../components/Icon.vue';
import InfoBulleHover from '../../../../components/InfoBulleHover.vue';
import MultipleField from '../../MultipleField.vue';
import IconComment from '../../../../components/Inputs/IconComment.vue';
import IconCommentHist from '../../IconCommentHist.vue';
import InputTextArea from '../../../../components/Inputs/InputTextArea.vue';

export default {
  components: {InputTextArea, IconCommentHist, IconComment, MultipleField, InfoBulleHover, Icon},
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      lastEvalTooltip: false,
      evalRefTooltip: false,
      commentTooltip: false,

      autoHidden: false,
      lastHidden: false,
    };
  },

  methods: {
    hide(what) {
      if (what === 'autoEval') {
        this.autoHidden  = !this.autoHidden;
      }
      if (what === 'lastEval') {
        this.lastHidden = !this.lastHidden;
      }
    },
    refEval(huh) {
      return this.form.items.value.filter((item) => item.value.name.newValue === huh.value.libelle.newValue)[0].value.refEval;
    }
  },
};
</script>

<template>
  <div>
    <div
      class="text-lg text-gray-600 grid grid-cols-10 gap-x-4 content-start h-16 2xl:h-24"
    >
      <div class="mx-10 col-span-3">
        Intitulé
      </div>
      <div class="col-span-2 text-center">
        Auto-évaluation
      </div>
      <div
        @mouseover="lastEvalTooltip = true"
        @mouseleave="lastEvalTooltip = false"
        class="col-span-2 text-center"
      >
        <info-bulle-hover
          :is-display-tooltip="lastEvalTooltip"
          name="lastEvalTooltip"
          libelle="Dernière évaluation du référent"
        />
        <span>Dernière éval.ref</span>
      </div>
      <div class="col-span-2 text-center">
        <span
          @mouseover="evalRefTooltip = true"
          @mouseleave="evalRefTooltip = false"
        >
          <info-bulle-hover
            :is-display-tooltip="evalRefTooltip"
            name="evalRefTooltip"
            libelle="Nouvelle évaluation du référent"
          />
          Nouvelle éval.ref
        </span>
      </div>
      <div
        @mouseover="commentTooltip = true"
        @mouseleave="commentTooltip = false"
        class="mr-10 col-span-1 text-center"
      >
        <info-bulle-hover
          :is-display-tooltip="commentTooltip"
          name="commentairesTooltip"
          libelle="Commentaires"
        />
        <span>Comm.</span>
      </div>

      <div
        class="col-start-4 col-span-2 flex items-center justify-center cursor-pointer"
        @click.stop="hide('autoEval')"
        title="Permission manquante"
      >
        <icon
          :name="autoHidden ? 'eye-off' : 'eye'"
          class="h-3 w-4 text-pink-600"
        />
        <span class="ml-3 text-sm select-none">{{
          autoHidden ? 'Afficher' : 'Masquer'
        }}</span>
      </div>
      <!-- beneficiary cannot display last evaluation -->
      <div
        class="col-span-2 flex items-center justify-center cursor-pointer"
        @click.stop="hide('lastEval')"
      >
        <icon
          :name="lastHidden ? 'eye-off' : 'eye'"
          class="h-3 w-4 text-pink-600"
        />
        <span class="ml-3 text-sm select-none">{{
          lastHidden ? 'Afficher' : 'Masquer'
        }}</span>
      </div>
      <div class="col-span-3" />
    </div>
    <!-- END line for pictograms -->

    <div
      v-for="(intitule, index) in this.form.template.value[1].value.criterions.value"
      :key="index"
      class="even:bg-gray-200 even:bg-opacity-50 grid grid-cols-10 gap-x-4 content-center py-5 xl:min-h-24 2xl:min-h-32 items-center"
    >
      <label
        class="col-span-3 ml-10 my-5 text-base"
        for="comprehension_ecrite"
      >
        {{ intitule.value.description.newValue }}
      </label>

      <multiple-field
        v-if="!autoHidden"
        class="md:col-span-2 lg:justify-self-center"
        :name="index + 'auto_eval'"
        label=""
        :value="form.items.value[index].value.autoEval"
      />

      <!-- if auto eval is hidden -->
      <div
        v-else
        class="col-span-2 justify-self-center"
      />

      <multiple-field
        v-if="!lastHidden"
        class="md:col-span-2 justify-self-center"
        :name="index + 'derniere_eval'"
        label=""
        :value="'RAS'/*
          Object.entries(latestEval).length > 0
            ? (
              ((latestEval.items || []).filter(
                (item) => item.name === intitule.libelle
              ) || [])[0] || {}
            ).refEval || 'Pas d\'évaluation récente'
            : 'Pas d\'évaluation récente'
        */"
      />

      <!-- if last eval is hidden -->
      <div
        v-else
        class="col-span-2 justify-self-center"
      />

      <multiple-field
        class="md:col-span-2 justify-self-center"
        :name="index + 'nouvelle_eval'"
        label=""
        :value="refEval(intitule)"
      />

      <icon-comment-hist
        :name="`comment-${index}`"
        class="cursor-pointer md:col-span-1 lg:place-self-center mr-10"
        :value="form.items.value[index].value.comment"
      />
    </div>

    <multiple-field
      class="px-10 mt-10"
      name="comment"
      label="Commentaire général"
      :value="form.comment"
    />
  </div>
</template>